import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Loader from './Loader';
import useSessionTimeout from 'hooks/useSessionTimeout';

// ==============================|| AUTH GUARD ||============================== //

export default function AuthGuard({ children }) {
  const navigate = useNavigate();
  useSessionTimeout();

  useEffect(() => {
    const user = localStorage.getItem('user');
    if (!user) {
      navigate('/login', { replace: true });
    }
  }, [navigate]);

  const user = localStorage.getItem('user');

  if (!user) {
    return <Loader />;
  }

  return <>{children}</>;
}
